import React from 'react';
import classNames from 'classnames';
import { snakeCase } from 'lodash';
import { withRouter, WithRouterProps } from 'react-router';

import CollapsingList from './collapsing_list';
import { SelectFacetOption } from './select_facet_option';
import { FilterProps, filterID, WidgetType } from './search_filters';
import { RCAccordion } from '@reverbdotcom/cadence/components';

const COLLAPSE_THRESHOLD = 7;


export function SelectFacet({
  filter,
  pageSection,
  trackingQuery,
  collapsible = false,
  defaultOpen = false,
  location,
  onToggleCallback,
}: FilterProps & WithRouterProps) {
  const labelId = `${pageSection}--${filterID(filter)}-lbl`;

  const isTraitFilter = filter.aggregationName === 'TRAITS';
  const parentNameOverride = isTraitFilter ? snakeCase(filter.name) : undefined;
  const filterOptions = (
    <CollapsingList
      countThreshold={isTraitFilter ? 3 : COLLAPSE_THRESHOLD}
      renderInFilterList
    >
      {filter.options.map((option) => (
        <SelectFacetOption
          key={option.name}
          option={option}
          checkbox={filter.widgetType === WidgetType.CHECKBOX}
          trackingQuery={trackingQuery}
          parentNameOverride={parentNameOverride}
          location={location}
        />
      ))}
    </CollapsingList>
  );

  const classes = classNames('facet', { 'facet--collapsible': collapsible });
  const anySelected = filter.options.some(opt => (opt.selected && !opt.all));

  return (
    <fieldset className={classes}>
      <RCAccordion
        id={labelId}
        heading={filter.name}
        defaultOpen={!collapsible || defaultOpen || anySelected}
        onToggle={onToggleCallback}
        locked={!collapsible}
        zeroPadding
      >
        {filterOptions}
      </RCAccordion>
    </fieldset>
  );
}

export default withRouter(SelectFacet);
